import React, { Children, cloneElement, MouseEventHandler } from "react"

import { useAccount, useLayerPopupContext } from "@shared/contexts"

const WithOpenLoginPopup: React.FC = ({ children }) => {
  const {
    account: { viewer },
  } = useAccount()
  const { open } = useLayerPopupContext()
  const child = Children.only(children) as React.ReactElement

  const isAnonymous = viewer?.role === "ANONYMOUS"

  const handlePopupOpen: MouseEventHandler = (e) => {
    if (isAnonymous) {
      open("ANONYMOUS")
      return
    }

    child.props.onClick?.(e)
  }

  return <>{cloneElement(child, { onClick: handlePopupOpen })}</>
}

export default WithOpenLoginPopup
